import { type RefObject, useCallback, useEffect, useState } from 'react';

export const useFocused = (ref: RefObject<HTMLElement | null>) => {
  const [isFocused, setFocused] = useState(false);

  const onFocus = useCallback(() => {
    setFocused(true);
  }, []);

  const onBlur = useCallback(() => {
    setFocused(false);
  }, []);

  useEffect(() => {
    const node = ref.current;

    node?.addEventListener?.('focus', onFocus);
    node?.addEventListener?.('blur', onBlur);

    return () => {
      node?.removeEventListener?.('focus', onFocus);
      node?.removeEventListener?.('blur', onBlur);
    };
  }, [ref, onFocus, onBlur]);

  return isFocused;
};
